/**
 * Utility functions for TemplateAnalyticsDialog
 */

export const formatPercentage = value => {
  if (value === null || value === undefined) return 'N/A';
  return `${value.toFixed(2)}%`;
};

export const formatCurrency = value => {
  if (value === null || value === undefined) return '$0.00';
  return `$${value.toFixed(4)}`;
};

export const formatDate = dateString => {
  if (!dateString) return 'N/A';
  try {
    return new Date(dateString).toLocaleString();
  } catch {
    return dateString;
  }
};

export const getSuccessRateColor = rate => {
  if (rate >= 95) return 'success';
  if (rate >= 80) return 'warning';
  return 'error';
};

export const getRatingColor = rating => {
  if (rating >= 4.5) return 'success';
  if (rating >= 3.5) return 'warning';
  if (rating >= 2.5) return 'info';
  return 'error';
};
